import React, { useEffect, useState } from "react";
import { FramesBar } from "@shared/components/NewFrameBar/FramesBar";
import { MapPane } from "@shared/components/MapPane";
import { NewToolbarButton } from "@shared/Toolbar/NewToolbarButton";
import { toolState } from "@shared/states/uiStates";
import { MapTool } from "@shared/types/tools";
import { MobileActionsButton } from "./MobileActionsButton";
import { MobileNavbar } from "./MobileNavbar";
import { MobileToolStrip } from "./MobileToolStrip";
import { SidebarDrawer } from "./SidebarDrawer";

export const MobileLayout = () => {
	const [sidebarOpen, setSidebarOpen] = useState(false);

	useEffect(() => {
		if (toolState.selectedTool === MapTool.MOVE) {
			toolState.selectedTool = MapTool.PAN;
		}
	}, []);

	return (
		<div className={"flex flex-col h-dvh overflow-hidden"}>
			<header className={"fixed inset-x-0 top-0 z-40"}>
				<MobileNavbar />
				<div
					className={
						"flex items-center gap-1 px-2 h-12 bg-base-300 border-b border-border-base-200"
					}
				>
					<MobileToolStrip />
					<MobileActionsButton />
					<div className={"shrink-0"}>
						<NewToolbarButton
							onClick={() => setSidebarOpen(true)}
							tooltipMessage={"Panels"}
							testId={"mobile-sidebar"}
						>
							<svg width={28} height={28} viewBox={"0 0 24 24"} fill={"none"}>
								<path
									d={"M4 6h16M4 12h16M4 18h16"}
									stroke={"white"}
									strokeWidth={2}
									strokeLinecap={"round"}
								/>
							</svg>
						</NewToolbarButton>
					</div>
				</div>
			</header>
			<div className={"flex flex-col flex-1 min-h-0 pt-24"}>
				<div className={"p-2 flex-1 min-h-0"}>
					<MapPane />
				</div>
				<FramesBar />
			</div>
			{sidebarOpen && <SidebarDrawer onClose={() => setSidebarOpen(false)} />}
		</div>
	);
};
